import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, tap, shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment.dev';
import { LoginService } from '../login/login.service';

import { toast } from 'ngx-sonner';


@Injectable({
  providedIn: 'root'
})
export class BcvService {
  private readonly API_URL = environment.apiUrl;
  api = '';
  api2 = ''
  headers: HttpHeaders;
  private tasa$: Observable<any> | null = null;

  constructor(private http: HttpClient, private router: Router, private loginService: LoginService) {
    this.api = `https://api.globalhousess.com/api`;
    this.headers = new HttpHeaders();
  }

  /**
   * Returns the tasa BCV. Caches the HTTP response and persists it in
   * localStorage under key 'tasa-bcv' to avoid repeated network calls.
   */
  getTasa(): Observable<any> {
    const cached = localStorage.getItem('tasa-bcv');
    if (cached) {
      try {
        return of(JSON.parse(cached));
      } catch {
        // fall through to live request if parse fails
      }
    }

    if (!this.tasa$) {
      this.tasa$ = this.http.get<any>(`${this.api}/bcv/tasa-bcv`).pipe(
        tap((resp) => {
          try {
            localStorage.setItem('tasa-bcv', JSON.stringify(resp));
          } catch (e) {
            // ignore storage errors
          }
        }),
        shareReplay(1)
      );
    }

    return this.tasa$;
  }


  public handleRequestError(error: any) {
    const msg = 'An error occurred while fetching products. Loading dummy data as fallback.';
    toast.error(msg, {
      position: 'bottom-right',
      description: error.message,
      action: {
        label: 'Undo',
        onClick: () => console.log('Action!'),
      },
      actionButtonStyle: 'background-color:#DC2626; color:white;',
    });
  }


}
